<template>
  <div class="publisher-brand-report">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true" style="fill: #fff">
        <use xlink:href="#icon-shangpin"></use>
      </svg>
    </breadcrumbs>
    <!-- <noticeTool /> -->
    <a-spin :spinning="spinning || spinningFlag || spinningTable">
      <div class="content-main" ref="mainRef">
        <div class="content-head">
          <p>
            <span v-if="tagNumParams.lastUpdateAt">
              Last Update at:
              {{ moment(tagNumParams.lastUpdateAt).format('YYYY-MM-DD hh:mm') }}
            </span>
          </p>
          <a-dropdown :getPopupContainer="() => mainRef">
            <template #overlay>
              <artmisads-dropdown-menu @click="handleExportClick">
                <a-menu-item key="all">Export All Data</a-menu-item>
                <a-menu-item key="filter">Export with Filters</a-menu-item>
              </artmisads-dropdown-menu>
            </template>
            <artmisads-button-special>
              <svg class="icon daochu" aria-hidden="true">
                <use xlink:href="#icon-daochu"></use>
              </svg>
              <span class="btn-text">Export</span>
              <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                <use xlink:href="#icon-jiantou-xia-cu"></use>
              </svg>
            </artmisads-button-special>
          </a-dropdown>
        </div>
        <filterBar
          :params="params"
          :getList="getList"
          :setParams="setParams"
          platform="publisher"
          type="trackingId"
        />
        <div class="tags">
          <filterTag
            :setParams="setParams"
            :tagNumParams="tagNumParams"
            :marketplace="params.marketplace"
            defaultMetricName="detailPageViews"
            :noNeedList="[
              'clicks',
              'conversionsRate',
              'acosAmount',
              'salesAmount',
              'bonusAmount',
              'commissionAndFeeAmount',
              'quantity',
              'ccCommissionAmount',
              'finalCommissionAmount',
              'finalCommissionAndFeeAmount'
            ]"
          />
        </div>

        <div class="content">
          <p>
            {{ RESPORTS_TYPE_MAP[params.metricName]?.name }}
            <span v-if="showTop10">(Top 10)</span>
            <a-radio-group
              @change="handleTrackingIdTypeChange"
              v-model:value="params.trackingIdType"
              :style="{ marginLeft: '8px' }"
            >
              <a-radio-button value="PRIMARY">Primary Id</a-radio-button>
              <a-radio-button value="SUB">Sub Id</a-radio-button>
            </a-radio-group>
          </p>

          <div class="chart">
            <chart
              :showDate="false"
              :dataList="dataList"
              :width="chartWidth"
              pageType="trackingId"
              :showYName="
                params.trackingIdType === 'PRIMARY'
                  ? 'primaryTrackingId'
                  : 'subTrackingId'
              "
              showXName="metricValue"
              :lineColor="chartParams.lineColor"
              :isPercent="params.metricName === 'conversionsRate'"
              :lineBgOffsetTop="chartParams.lineBgOffsetTop"
              :lineBgOffsetZero="chartParams.lineBgOffsetZero"
              chartType="bar"
              :selectDaysNum="selectDaysNum"
              :showCurrent="false"
              defaultMetricName="detailPageViews"
              :startTimestamp="params.startReportDateTimestamp"
              :endTimestamp="params.endReportDateTimestamp"
              :onClickBarChart="onClickBarChart"
              :metricName="params.metricName"
            />
          </div>
          <div class="table">
            <tableContent
              :expandedRowKeys="expandedRowKeys"
              :setExpandedRowKeys="setExpandedRowKeys"
              :dataList="tableList"
              :marketplace="params.marketplace"
              :tableTotal="tableTotal"
              :params="tableParams"
              :setParams="setTableParams"
              :onClickTableChart="onClickTableChart"
              :onClickTableDetail="onClickTableDetail"
              :tagNumParams="tagNumParams"
            />
          </div>
        </div>
      </div>
    </a-spin>
    <lineChartModal
      v-if="showlineChartModal"
      title="Tracking ID Report"
      :itemInfo="itemInfo"
      :onCancleModal="onCancleModal"
      pageType="trackingId"
      :defaultMetricName="params.metricName"
      :marketplace="params.marketplace"
      :noNeedList="[
        'clicks',
        'acosAmount',
        'conversionsRate',
        'salesAmount',
        'bonusAmount',
        'commissionAndFeeAmount',
        'finalCommissionAmount',
        'finalCommissionAndFeeAmount'
      ]"
    />
    <trackingTableModal
      v-if="showTrackingTableModal"
      :onCancleModal="onCancleModalTrackingTableModal"
      :dataList="trackingTableList"
      :tableTotal="trackingTableTotal"
      :params="trackingTableParams"
      :setParams="setTrackingTableParams"
      :loading="trackingTableModalLoading"
      :itemInfo="itemInfo"
    />
  </div>
</template>
<script setup>
import { computed, onMounted, ref, watch, onBeforeMount } from 'vue'
import moment from 'moment'
import { publisherReportsApi } from '~/server/index'
import { RESPORTS_TYPE_MAP } from '~/contants/reports'
import breadcrumbs from '~/components/breadcrumbs.vue'
import filterBar from '~/components/reports/filterBar.vue'
import filterTag from '~/components/reports/filterTag.vue'
import lineChartModal from '~/components/reports/lineChartModal.vue'
import noticeTool from '~/components/reports/noticeTool.vue'
import chart from '~/components/reports/chart.vue'
import tableContent from './tableContent.vue'
import trackingTableModal from './trackingTableModal.vue'

const breadcrumbsData = {
  title: 'Tranking Id Reports',
  color: '#4682FA',
  // hasTitleIcon:true,
  links: [
    {
      name: 'Home',
      path: '/publisher/dashboard',
    },
    {
      name: 'Reports',
      path: '/publisher/reports/performance',
    },
    {
      name: 'Tranking Id Reports',
      path: '/publisher/reports/trankingId',
    },
  ],
}
const needOpenBrandId = ref('')
const showTop10 = ref(false)
const showlineChartModal = ref(false)
const chartWidth = ref(1092)
const spinning = ref(false)
const spinningFlag = ref(false)
const spinningTable = ref(false)
const trackingTableModalLoading = ref(false)
const dataList = ref([])
const expandedRowKeys = ref([])
const params = ref({
  marketplace: 'amazon.com',
  startReportDateTimestamp: moment()
    .subtract(30, 'day')
    .startOf('day')
    .valueOf(),
  endReportDateTimestamp: moment().startOf('day').valueOf(),
  primaryTrackingId: null,
  subTrackingId: null,
  metricName: 'detailPageViews',
  trackingIdType: 'PRIMARY',
  stat: 'all',
})
const itemInfo = ref()
const mainRef = ref()
const tableList = ref([])
const tableTotal = ref(0)
const showTrackingTableModal = ref(false)
const trackingTableList = ref([])
const trackingTableTotal = ref(0)
const trackingTableParams = ref({
  page: 1,
  size: 10,
  marketplace: 'amazon.com',
  primaryTrackingId: undefined,
  subTrackingId: undefined,
  promotionType: 'product',
  startReportDateTimestamp: moment()
    .subtract(30, 'day')
    .startOf('day')
    .valueOf(),
  endReportDateTimestamp: moment().startOf('day').valueOf(),
  sortDirection: 'desc',
  sortField: 'commissionAmount',
})
const tableParams = ref({
  page: 1,
  size: 200,
  sortDirection: 'desc',
  sortField: 'commissionAmount',
})

const tagNumParams = ref({
  totalClicks: null,
  totalDetailPageViews: null,
  totalAddToCart: null,
  totalConversions: null,
  totalConversionsRate: null,
  totalSalesAmount: null,
  totalDiscountedSalesAmount: null,
  totalBonusAmount: null,
  totalCommissionAmount: null,
  lastUpdateAt: null,
})
const handleTrackingIdTypeChange = (e) => {
  // setParams({ trackingIdType: e.target.value });
  // params.value.trackingIdType = e.target.value;
  getList()
}
const selectDaysNum = computed(() => {
  const { endReportDateTimestamp, startReportDateTimestamp } = params.value
  const intervalDays = moment(endReportDateTimestamp).diff(
    moment(startReportDateTimestamp),
    'days',
  )
  return intervalDays
})

const chartParams = computed(() => {
  let lineColor, lineBgOffsetTop, lineBgOffsetZero, chartParamsData, itemData
  itemData = RESPORTS_TYPE_MAP[params.value.metricName]
  lineColor = itemData.lineColor
  lineBgOffsetTop = itemData.lineBgOffsetTop
  lineBgOffsetZero = itemData.lineBgOffsetZero
  chartParamsData = { lineColor, lineBgOffsetTop, lineBgOffsetZero }
  return chartParamsData
})

const getChartWidth = () => {
  const $chart = document.querySelector('.chart')
  const widthNum = $chart.clientWidth - 20
  chartWidth.value = widthNum
}

const setTableParams = (obj) => {
  const newObj = { ...tableParams.value, ...obj }
  tableParams.value = newObj
}
const setTrackingTableParams = (obj) => {
  const newObj = { ...trackingTableParams.value, ...obj }
  trackingTableParams.value = newObj
}
const setExpandedRowKeys = (keys) => {
  expandedRowKeys.value = keys
}
const setParams = (obj) => {
  expandedRowKeys.value = []
  const newObj = { ...params.value, ...obj }
  if (newObj.subTrackingId) {
    newObj.stat = 'sub'
    expandedRowKeys.value = [newObj.primaryTrackingId]
    // console.log('expandedRowKeys', expandedRowKeys.value)
  } else {
    newObj.stat = 'all'
  }
  setTableParams({ page: 1 })
  params.value = JSON.parse(JSON.stringify(newObj))
}

watch(params, async (newValue, oldValue) => {
  // console.log('newValue', newValue, oldValue)
  if (newValue.metricName !== oldValue.metricName) {
    getList()
  } else if (newValue.trackingIdType !== oldValue.trackingIdType) {
    getList()
  } else {
    getPublisherCommissionReportsAgg()
    getList()
    getTableList()
  }
})

watch(tableParams, async () => {
  getTableList()
})
watch(trackingTableParams, async () => {
  getTrackingTableList()
})
const onClickBarChart = async (clickData) => {
  const { trackingIdType, startReportDateTimestamp, endReportDateTimestamp } =
    params.value

  // 从新的参数格式中获取数据
  const yName = clickData.name || clickData // 兼容旧格式
  let item = clickData.itemData

  // 如果没有通过itemData获取到数据，使用原来的查找方式
  if (!item) {
    item =
      trackingIdType === 'PRIMARY'
        ? dataList.value.find((i) => i.primaryTrackingId == yName)
        : dataList.value.find(
            (i) =>
              i.subTrackingId == yName[1] && i.primaryTrackingId == yName[0],
          )
  }
  if (!item) return

  // 设置项目信息
  itemInfo.value = {
    ...item,
    ...(trackingIdType === 'PRIMARY' && { primaryTrackingIds: yName }),
    startReportDateTimestamp,
    endReportDateTimestamp,
    stat: trackingIdType === 'PRIMARY' ? 'all' : 'sub',
  }

  showlineChartModal.value = true
}
const getTrackingTableList = async () => {
  trackingTableModalLoading.value = true
  trackingTableList.value = []
  trackingTableTotal.value = 0
  // console.log(trackingTableParams.value,'trackingTableParams.value')
  try {
    const { success, data } =
      await publisherReportsApi.getPublisherCommissionReportsTrackingIdDetail(
        trackingTableParams.value,
      )

    if (success) {
      trackingTableList.value = data.data
      trackingTableTotal.value = data.total
    }
  } catch (error) {
    console.error('获取跟踪表格数据失败:', error)
  } finally {
    trackingTableModalLoading.value = false
  }
}
const onClickTableChart = (item) => {
  itemInfo.value = item
  itemInfo.value.startReportDateTimestamp =
    params.value.startReportDateTimestamp
  itemInfo.value.endReportDateTimestamp = params.value.endReportDateTimestamp

  if (itemInfo.value.children) {
    itemInfo.value.stat = 'all'
  } else {
    let stat = 'primaryId'
    if (itemInfo.value.primaryTrackingIds) {
      stat = 'primaryId'
    } else {
      stat = 'sub'
    }
    itemInfo.value.stat = stat
  }

  showlineChartModal.value = true
}
const onClickTableDetail = (item) => {
  itemInfo.value = item
  // 第一层数据
  if (itemInfo.value.children) {
    const newParams = {
      primaryTrackingId: itemInfo.value.primaryTrackingIds,
      subTrackingId: undefined,
      startReportDateTimestamp: params.value.startReportDateTimestamp,
      endReportDateTimestamp: params.value.endReportDateTimestamp,
      marketplace: params.value.marketplace,
      promotionType: 'product',
      page: 1,

      stat: 'all',
    }

    setTrackingTableParams(newParams)
    // trackingTableParams.value.primaryTrackingId = ;
  }
  // 第二层数据
  else {
    let stat = 'primaryId'
    if (itemInfo.value.primaryTrackingIds) {
      stat = 'primaryId'
    } else {
      stat = 'sub'
    }
    setTrackingTableParams({
      primaryTrackingId: itemInfo.value.primaryTrackingId,
      subTrackingId: itemInfo.value.subTrackingId,
      startReportDateTimestamp: params.value.startReportDateTimestamp,
      endReportDateTimestamp: params.value.endReportDateTimestamp,
      marketplace: params.value.marketplace,
      promotionType: 'product',
      page: 1,
      stat,
    })
  }
  showTrackingTableModal.value = true
}
const onCancleModalTrackingTableModal = () => {
  showTrackingTableModal.value = false
}
const onCancleModal = () => {
  showlineChartModal.value = false
  itemInfo.value = undefined
}

const getList = async () => {
  spinning.value = true
  dataList.value = []

  try {
    const requestParams = { ...params.value }
    const { success, data } =
      await publisherReportsApi.getPublisherCommissionTrackingIdMetric(
        requestParams,
      )

    if (success) {
      // 限制显示前10条数据
      if (data.length > 10) {
        data.splice(10)
        showTop10.value = true
      }

      // 转换率数据需要转换为百分比格式
      dataList.value =
        requestParams.metricName === 'conversionsRate'
          ? data.map((item) => ({
              ...item,
              metricValue: (item.metricValue * 100)
                .toFixed(2)
                .replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1'),
            }))
          : data
    }
  } catch (error) {
    console.error('获取图表数据失败:', error)
  } finally {
    spinning.value = false
  }
}

const getTableList = async () => {
  spinningTable.value = true
  tableList.value = []
  tableTotal.value = 0

  try {
    const requestParams = { ...params.value, ...tableParams.value }
    const { success, data } = await publisherReportsApi.getReportsTrackingId(
      requestParams,
    )

    if (success) {
      tableList.value = data.data.map((item, index) => {
        // 生成子项数据的辅助函数
        const createSubItem = (subItem, subIndex) => ({
          ...subItem,
          id: `${item.primaryTrackingId}_${index}_sub_${subIndex}`,
          primaryTrackingIds: subItem.subTrackingId
            ? undefined
            : subItem.primaryTrackingId,
        })

        // 判断是否需要创建子项
        const shouldCreateChildren = () => {
          const subList = item?.subTrackingIdList
          if (!subList?.length) return false

          if (subList.length > 1) return true
          if (subList.length === 1 && subList[0].subTrackingId) return true

          return false
        }

        return {
          ...item,
          id: item.primaryTrackingId,
          primaryTrackingIds: item.primaryTrackingId,
          children: shouldCreateChildren()
            ? item.subTrackingIdList.map(createSubItem)
            : undefined,
        }
      })
      console.log(tableList.value, 'tableList.value')
      tableTotal.value = data.total
    }
  } catch (error) {
    console.error('获取表格数据失败:', error)
  } finally {
    spinningTable.value = false
  }
}

const getPublisherCommissionReportsAgg = async () => {
  spinningFlag.value = true
  let stat = 'all'
  try {
    if (params.value.subTrackingId) {
      stat = 'sub'
    }
    const requestParams = {
      ...params.value,
      trackingIdType: undefined,
      stat: stat,
    }
    const { success, data } =
      await publisherReportsApi.getPublisherCommissionReportsTrackingIdAgg(
        requestParams,
      )

    if (success) {
      tagNumParams.value = data
    }
  } catch (error) {
    console.error('获取聚合数据失败:', error)
  } finally {
    spinningFlag.value = false
  }
}

const handleExportClick = async ({ key }) => {
  let exportParams = {
      endReportDateTimestamp: moment().startOf('day').valueOf(),
      marketplace: params.value.marketplace,
      startReportDateTimestamp: moment()
        .subtract(1825, 'day')
        .startOf('day')
        .valueOf(),
      sortDirection: 'desc',
      sortField: 'commissionAmount',
    },
    newExportParams = {}
  if (key === 'filter') {
    const parma = {
      ...params.value,
      sortDirection: 'desc',
      sortField: 'commissionAmount',
    }
    delete parma.trackingIdType
    exportParams = { ...parma }
  }
  for (let item in exportParams) {
    if (exportParams[item]) {
      newExportParams[item] = exportParams[item]
    }
  }
  const finalParams = {
    qs: newExportParams,
    fileName: `Tranking-Id-Reports-${moment().format('YYYY-MM-DD')}.csv`,
  }
  publisherReportsApi.exportCommissionTrackingIdReports(finalParams)
}

const checkFromDashboard = () => {
  const artemisAds_dashboard_click_top_brand = localStorage.getItem(
    'artemisAds_dashboard_click_top_brand',
  )
  if (artemisAds_dashboard_click_top_brand) {
    needOpenBrandId.value = artemisAds_dashboard_click_top_brand
    localStorage.setItem('artemisAds_dashboard_click_top_brand', '')
  }
}

onBeforeMount(() => {
  checkFromDashboard()
})

onMounted(() => {
  getChartWidth()
  getList()
  getTableList()
  getPublisherCommissionReportsAgg()
  // getTrackingTableList()
  window.addEventListener('resize', function () {
    getChartWidth()
  })
})
</script>
<style lang="less" scoped>
:deep(.indent-level-1) {
  padding-left: 0 !important;
}
.publisher-brand-report {
  .content-main {
    border-radius: 12px;
    overflow: hidden;
    border-radius: 12px;
    background-color: var(--color-white);
    box-shadow: var(--section-box-shadow-6);

    .tags {
      padding: 20px 12px;
    }

    .content-head {
      display: flex;
      justify-content: space-between;
      height: 64px;
      padding-left: 16px;
      padding-right: 16px;

      > p {
        font-size: 14px;
        color: var(--dark-2);
        line-height: 19px;
        align-self: center;
      }

      > button {
        align-self: center;
        cursor: pointer;
        display: flex;

        .jiantou {
          width: 16px;
          height: 16px;
          fill: var(--dark-3);
          margin-left: 8px;
        }

        .daochu {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          fill: var(--dark-1);
        }

        > svg {
          align-self: center;
        }

        > span {
          align-self: center;
        }

        .btn-text {
          align-self: center;
          font-weight: 500;
          line-height: 20px;
          margin-right: 8px;
        }
      }
    }
  }

  .content {
    padding: 16px;

    .table {
      margin-top: 40px;
    }

    .chart {
      padding: 0 10px;
    }

    > p {
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      line-height: 28px;
      margin-bottom: 30px;

      > span {
        color: var(--red-text);
        font-size: 16px;
        margin-left: 10px;
        line-height: 28px;
      }
    }
  }
}
</style>
